import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';
import { MapPin, Eye, Clock } from 'lucide-react';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const categoryStyles = {
  sale: { label: 'For Sale', className: 'bg-[#F4F1EA] text-[#2C362F] border-0' },
  free: { label: 'Free', className: 'bg-[#E5B66A]/10 text-[#2C362F] border-0' },
  lending: { label: 'Lending', className: 'bg-[#7D9B8B]/10 text-[#7D9B8B] border-0' },
};

export default function ListingCard({ listing }) {
  const cat = categoryStyles[listing.category] || categoryStyles.sale;
  const imageUrl = listing.images && listing.images.length > 0
    ? `${API_BASE}/api/files/${listing.images[0]}`
    : 'https://images.unsplash.com/photo-1578653282816-a508bd2d0435?w=400&h=300&fit=crop';

  const timeAgo = (dateStr) => {
    const diff = Date.now() - new Date(dateStr).getTime();
    const mins = Math.floor(diff / 60000);
    if (mins < 60) return `${mins}m ago`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return `${hrs}h ago`;
    const days = Math.floor(hrs / 24);
    if (days < 7) return `${days}d ago`;
    return new Date(dateStr).toLocaleDateString();
  };

  return (
    <Link
      to={`/listings/${listing.listing_id}`}
      className="group block"
      data-testid={`listing-card-${listing.listing_id}`}
    >
      <div className="bg-white border border-[#E8E6DF] rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1">
        <div className="relative aspect-[4/3] overflow-hidden bg-muted">
          <img
            src={imageUrl}
            alt={listing.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          <Badge className={`absolute top-3 left-3 rounded-full text-xs font-semibold px-3 py-1 ${cat.className}`}>
            {cat.label}
          </Badge>
        </div>
        <div className="p-4">
          <h3 className="font-semibold text-[#2C362F] line-clamp-1 mb-1 group-hover:text-primary transition-colors" style={{ fontFamily: 'Outfit, sans-serif' }} data-testid="listing-card-title">
            {listing.title}
          </h3>
          <p className="text-sm text-muted-foreground line-clamp-2 mb-3 leading-relaxed">
            {listing.description}
          </p>
          <div className="flex items-center justify-between">
            <div>
              {listing.category === 'sale' && listing.price != null ? (
                <span className="font-bold text-lg text-primary" data-testid="listing-card-price">
                  £{listing.price.toFixed(2)}
                </span>
              ) : listing.category === 'free' ? (
                <span className="font-semibold text-[#7D9B8B]">Free</span>
              ) : (
                <span className="font-semibold text-[#7D9B8B]">Lending</span>
              )}
            </div>
            <div className="flex items-center gap-3 text-xs text-muted-foreground">
              {listing.location && (
                <span className="flex items-center gap-1">
                  <MapPin className="w-3 h-3" strokeWidth={1.5} />{listing.location}
                </span>
              )}
              <span className="flex items-center gap-1">
                <Clock className="w-3 h-3" strokeWidth={1.5} />{timeAgo(listing.created_at)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
